import React from "react";
import Breadcrumb_Comp from "../../common/common_components/breadcrumb_comp/Breadcrumb_Comp";
import './Panic_Healing_Banner.css'
import { IDS } from "../../../utils/IDS";

const Panic_Healing_Banner = ({ data }) => {

  const breadcrumbs = [
    { label: "SPANDAN", link: "/spandan", active: false },
    {
      label: data?.name || "",
      link: "",
      active: true,
    },
  ];

  return (
    <section className="Panic_Healing_Banner">
      <div className="container">
        <div className="breadcrump_div">
          <Breadcrumb_Comp data={breadcrumbs} />
        </div>

        <div className="banner_holder">
          <img
            src={`${IDS.IMG_URL + data?.Spandan_Session_Type?.image}`}
            className="banner_img"
          />
        </div>
      </div>
    </section>
  );
};

export default Panic_Healing_Banner;
